import { connect } from 'react-redux';

import { IPhoneButtonSwitcherProps, PhoneButtonSwitcher } from '../../components/PhoneButtonSwitcher';
import { IState } from '../../store';
import { trackingPhoneEvent } from '../../store/tracking/mobile';
import { TTypedThunkDispatch } from '../../types/store';

type TStoreProps = Pick<IPhoneButtonSwitcherProps, 'phone'>;
type TDispatchProps = Pick<IPhoneButtonSwitcherProps, 'trackShowPhoneClick'>;

export function mapStateToProps(state: IState): TStoreProps {
  const { builder } = state.villageData.village || {};

  return {
    phone: builder?.displayPhone ? builder.phone : undefined,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): TDispatchProps {
  return {
    trackShowPhoneClick() {
      dispatch(trackingPhoneEvent('Open_KP_card_blockKP'));
    },
  };
}

export const PhoneButtonContainer = connect<TStoreProps, TDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(PhoneButtonSwitcher);
